import { useEffect } from "react";

type UseResetVideoReadyOnConstraintsEffectProps = {
  videoConstraints: MediaTrackConstraints;
  setIsVideoReady: (val: boolean) => void;
};

// Reset video ready state when video constraints change
export function useResetVideoReadyOnConstraintsEffect({
  videoConstraints,
  setIsVideoReady,
}: UseResetVideoReadyOnConstraintsEffectProps) {
  useEffect(() => {
    setIsVideoReady(false);
  }, [videoConstraints, setIsVideoReady]);
}
